import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

const useSessionStorage = <T>(
    key: string,
    initialValue: T,
    parser?: (value: string) => T,
): [T, Dispatch<SetStateAction<T>>] => {
    const [value, setValue] = useState<T>(() => {
        const stored = sessionStorage.getItem(key);

        if (!stored) {
            return initialValue;
        }

        try {
            return parser ? parser(stored) : JSON.parse(stored);
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};

export { useSessionStorage };
